export default {
    INVOICE_KEY(chaveAcesso){
        if (!chaveAcesso || chaveAcesso.trim().length !== 44) {
            return false
        }

        const chaveParcial = chaveAcesso.substring(0, 43)
        const multiplicadores = [2, 3, 4, 5, 6, 7, 8, 9]

        let i = 42
        let somaPonderada = 0

        while (i >= 0) {
            for (let j = 0; (j < multiplicadores.length && i >= 0); j++) {
                somaPonderada += chaveParcial[i] * multiplicadores[j]
                i -= 1
            }
        }

        const resto = somaPonderada % 11
        const dv = (resto === 0 || resto === 1) ? 0 : 11 - resto

        return String(dv) === chaveAcesso.substring(43, 44)
    }
};
